import React from 'react';
import Modal from 'react-bootstrap/Modal';
import ActionsTable from './ActionsTable';
import InputField from '../Reusable/InputField';
import ButtonSave from '../Reusable/ButtonSave';
import withTranslations from '../../utils/HighOrderComponent';

class ModalForAddRole extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      roleName: '',
      listOfActionstToChoose: this.props.actionList.slice(),
      selectedActions: [],
      actionListCopy: this.props.actionList.slice(),
      messageErrorClientValidationRoleName: '',
      errors: {},
    };
  }

  handleComboBoxChange = (object, objectId) => {
    return (e) => {
      this.setState({ [object]: { [objectId]: e.target.value } });
    };
  };

  handleClose = () => {
    this.props.handleClose();
  };

  addActions = (newSelectedActions) => {
    let listOfActionObjects =
      this.addChosenActionsToListListOfSelectedActions(newSelectedActions);

    this.setState({
      selectedActions: this.state.selectedActions.concat(listOfActionObjects),
    });
    let newListOfActionstToChoose =
      this.removeChosenActionsFromListOfActionsToChoose(
        this.state.listOfActionstToChoose,
        newSelectedActions
      );

    this.setState({
      listOfActionstToChoose: newListOfActionstToChoose,
    });
  };

  addChosenActionsToListListOfSelectedActions = (newSelectedActions) => {
    let listOfActionObjects = [];
    for (let i = 0; i < newSelectedActions.length; i++) {
      for (let j = 0; j < this.state.actionListCopy.length; j++) {
        if (
          newSelectedActions[i] ===
          this.state.actionListCopy[j].actionDescription
        ) {
          listOfActionObjects.push(this.state.actionListCopy[j]);
        }
      }
    }
    return listOfActionObjects;
  };

  removeChosenActionsFromListOfActionsToChoose = (
    listOfActionstToChoose,
    newSelectedActions
  ) => {
    let newListOfActionstToChoose = listOfActionstToChoose;
    for (let i = 0; i < newSelectedActions.length; i++) {
      for (let j = 0; j < newListOfActionstToChoose.length; j++) {
        if (
          newListOfActionstToChoose[j].actionDescription ===
          newSelectedActions[i]
        ) {
          newListOfActionstToChoose.splice(j, 1);
        }
      }
    }
    return newListOfActionstToChoose;
  };

  removeActions = (actionsForRemoving) => {
    let listOfActionObjects =
      this.addRemovedActionToListOfActionsToChoose(actionsForRemoving);

    this.setState({
      listOfActionstToChoose:
        this.state.listOfActionstToChoose.concat(listOfActionObjects),
    });

    let newListOfSelectedActions =
      this.removeChosenActionsFromListOfSelectedActions(
        this.state.selectedActions,
        actionsForRemoving
      );

    this.setState({
      selectedActions: newListOfSelectedActions,
    });
  };

  addRemovedActionToListOfActionsToChoose = (actionsForRemoving) => {
    let listOfActionObjects = [];
    for (let i = 0; i < actionsForRemoving.length; i++) {
      for (let j = 0; j < this.state.actionListCopy.length; j++) {
        if (
          actionsForRemoving[i] ===
          this.state.actionListCopy[j].actionDescription
        ) {
          listOfActionObjects.push(this.state.actionListCopy[j]);
        }
      }
    }
    return listOfActionObjects;
  };

  removeChosenActionsFromListOfSelectedActions = (
    listOfActionstToChoose,
    actionsForRemoving
  ) => {
    let newListOfSelectedActions = listOfActionstToChoose;
    for (let i = 0; i < actionsForRemoving.length; i++) {
      for (let j = 0; j < newListOfSelectedActions.length; j++) {
        if (
          newListOfSelectedActions[j].actionDescription ===
          actionsForRemoving[i]
        ) {
          newListOfSelectedActions.splice(j, 1);
        }
      }
    }
    return newListOfSelectedActions;
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  createValidActionListForCreateAction = () => {
    let selectedActions = this.state.selectedActions;
    let actions = [];
    for (let i = 0; i < selectedActions.length; i++) {
      actions.push(selectedActions[i].actionName);
    }
    return actions;
  };

  handleErrorMessage = (
    error,
    serverValidationMessage,
    clientValidationMessage
  ) => {
    return error
      ? error[serverValidationMessage]
      : this.state[clientValidationMessage] !== ''
      ? this.state[clientValidationMessage]
      : '';
  };

  refreshClientValidation = () => {
    this.setState({ messageErrorClientValidationRoleName: '' });
  };

  handleClientValidation = () => {
    this.props.deleteError();
    this.refreshClientValidation();

    let hasError = false;

    if (this.state.roleName === '') {
      this.setState({
        messageErrorClientValidationRoleName: this.props.t.Errors.roleNameEmpty,
      });
      hasError = true;
    }

    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.handleClientValidation() === true) {
      return;
    }
    const newRole = {
      roleName: this.state.roleName,
      actions: this.createValidActionListForCreateAction(),
    };
    this.props.handleAdd(newRole);
  };

  render() {
    const { error } = this.props;
    let selectedActions = this.state.selectedActions;
    let listOfActionstToChoose = this.state.listOfActionstToChoose;

    return (
      <Modal
        className="modal"
        show={this.props.show}
        onHide={this.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <h5 className="title">{this.props.t.Labels.title}</h5>
            <hr />
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <InputField
                      name="roleName"
                      placeholder={this.props.t.Placeholders.roleName}
                      onChange={this.onChange}
                      value={this.state.roleName}
                      error={this.handleErrorMessage(
                        error,
                        'roleName',
                        'messageErrorClientValidationRoleName'
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-12 row">
                  <div className="col-md-5">
                    <ActionsTable
                      allActionsTable={true}
                      actionList={listOfActionstToChoose}
                      addActions={this.addActions}
                      placeholderTitle={
                        this.props.t.Placeholders.ActionsTable
                          .allActionsListTitle
                      }
                      placeholderSelectAllActions={
                        this.props.t.Placeholders.ActionsTable.selectAllActions
                      }
                    />
                  </div>
                  <div className="col-md-2"></div>
                  <div className="col-md-5">
                    <ActionsTable
                      allActionsTable={false}
                      actionList={selectedActions}
                      removeActions={this.removeActions}
                      placeholderTitle={
                        this.props.t.Placeholders.ActionsTable
                          .chosenActionsListTitle
                      }
                      placeholderSelectAllActions={
                        this.props.t.Placeholders.ActionsTable.selectAllActions
                      }
                    />
                  </div>
                </div>
              </div>

              <br />
              <div className="row">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(ModalForAddRole, 'ModalForAddRole');
